import CryptoJS from 'crypto-js';


// Save encrypted value of a key
export const encryptKeyValue = (key, value) => {
    const stringValue = typeof value === 'string' ? value : JSON.stringify(value); // Convert array/object to string
    const encryptedValue = CryptoJS.AES.encrypt(stringValue, process.env.REACT_APP_SECRET_ENCRYPTION_KEY).toString();
    localStorage.setItem(key, encryptedValue);
};




// get decryptKeyValue value of a key
export const decryptKeyValue = (key) => {
    const encryptedKeyValue = localStorage.getItem(key);
    if (encryptedKeyValue) {
        const bytes = CryptoJS.AES.decrypt(encryptedKeyValue, process.env.REACT_APP_SECRET_ENCRYPTION_KEY);
        const decryptedValue = bytes.toString(CryptoJS.enc.Utf8);
        try {
            // Try to parse the decrypted value back into an object/array
            return JSON.parse(decryptedValue);
        } catch (e) {
            // If parsing fails, it's likely a simple string, so return as-is
            return decryptedValue;
        }
    }
    return null;
};

export const convertToAmPm = (slot, onlyStartTime = false) => {
    const [start, end] = slot.split(" - ");
    const convert = (time) => {
        const [hour, minute] = time.split(":");
        const h = parseInt(hour, 10);
        const period = h >= 12 ? "PM" : "AM";
        const formattedHour = h % 12 || 12; // Convert 0 to 12 for 12-hour format
        return `${formattedHour}:${minute} ${period}`;
    };

    if (onlyStartTime) {
        return convert(start);
    }
    return `${convert(start)} - ${convert(end)}`;
};


export const normalizePermissions = (permissions) => {
    return Object.keys(permissions).reduce((acc, key) => {
        const normalizedKey = key.toUpperCase();
        acc[normalizedKey] = permissions[key];
        return acc;
    }, {});
};

export const capitalizeWords = (text) => {
    return text
        .toLowerCase()
        .replace(/_/g, ' ') // Replace underscores with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize the first letter of each word
};



export const routes = {


    home: '/',
    guide: '/crm/guide',
    dashboard: '/crm/dashboard',
    review: '/crm/review',
    walker: '/crm/walker',
    order: '/crm/order',
    order_detail: '/crm/order/:id?',
    user: '/crm/user',
    user_detail: '/crm/user/:email?',
    pet: '/crm/pet',
    walk: '/crm/paw-walk',
    walk_single: '/crm/paw-walk/:walk_id?',
    delivery: '/crm/paw-taxi',
    delivery_single: '/crm/paw-taxi/:delivery_id?',
    profile: '/profile/:username?',
    payment_success: '/payment/success',
    payment_failed: '/payment/failed',

    // setting
    setting: '/crm/setting',
    pet_type: '/crm/setting/pet-type',
    pet_breed: '/crm/setting/pet-breed',
    pet_allergy: '/crm/setting/pet-allergy',
    membership: '/crm/setting/membership',
    role: '/crm/setting/role',
    promo_code: '/crm/setting/promo-code',
    permission: '/crm/setting/permission',
    walk_tool: '/crm/setting/walk-tool',
    partner: '/crm/setting/partner',


    // Auth
    login: '/auth/login',
    registration: '/auth/registration',
    verify: '/auth/verify-account',
    forgot_password: '/auth/forgot-password',
    reset_password: '/auth/reset-password',


    // policy
    terms: '/terms',
    privacy_policy: '/privacy-policy',
    eula: '/end-user-license-agreement',

    // error
    403: '/access-denied',
    account_deletion: '/auth/delete-account',
    account_deletion_verify: '/account-deletion/verify/:token',
    account_deletion_status: '/account-deletion/status',
    account_deletion_admin: '/crm/account-deletions',
};



